<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/19D5aU1/images/cover.jpg?1685327251434" alt="This image is the cover for the book The Companion"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Companion
      </h1>
      <p class="bookDescription body article font2">
        <p>Shepherd Bucknam hasn’t had a lover in more than a decade and doesn’t need one. As a Daka, he coaches men in the sacred art and mystery of sexual ecstasy all the time, and he loves his work. It’s his calling. In fact, he’s perfectly content—except for the terrors of his recurring nightmare and the ominous blood-red birthmarks on his neck. He’s convinced that together they foretell his early and violent death.</p> <p>When Shepherd’s young protégé is murdered, LAPD Detective Marco Fidanza gets the case. The two men are worlds apart: Marco has fought hard for everything he’s accomplished, in sharp contrast to the apparent ease of Shepherd’s inherited wealth—but their mutual attraction is too hot for either of them to ignore.</p> <p>Shepherd swears he’ll help find his protégé’s killer, but Marco warns him to stay out of it. When an influential politician is implicated, the police investigation grinds to a halt. Shepherd hires his own investigator. Marco calls it dangerous meddling. As their volatile relationship deepens, Shepherd discovers his nightmares might not relate to the future, but to the deadly legacy of a past life—a life he may have to revisit before he can fully live and love in this one.</p> <p><a href="http://www.lambdaliterary.org/features/news/03/04/the-27th-annual-lambda-literary-award-finalists/" target="_blank"><img alt="2015 Lambda Literary Award Finalist" height="200" src="http://i638.photobucket.com/albums/uu102/dreamspinnerpress/Award%20banners/LammyFinalist2015.jpg" style="display: block; margin-left: auto; margin-right: auto;" width="198"/></a></p> <p style="text-align: center;"><strong><span style="font-size: med;">2015 Lambda Literary Award Finalist in Gay Romance</span></strong></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lloyd A. Meeker
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6aa6dcf2